/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // CUSTOM INFINITE SCROLL 
  function registerInfiniteScrollLoadMoreButton() {
    const selectors = {
      loadMoreButton: ".js-load-more",
      loadMoreContainer: ".load-more__container",
      totalPages: "[data-total-pages]",
      currentPage: "[data-current-page]",
      nextUrl: "[data-next-url]",
      loadMoreText: "[load-more-text]",
      loaderText: "[loader-text]",
      products: ".collection__products .grid-item.product-item:not(.product-grid-item-placeholder)",
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      totalProducts: ".total-products",
    };

    const hideClass = "hidden";
    const loadMoreButton = document.querySelector(selectors.loadMoreButton);
    const loadMoreContainer = document.querySelector(selectors.loadMoreContainer);
    const currentProducts = document.querySelector(selectors.currentProducts);
    const totalProducts = document.querySelector(selectors.totalProducts);
    const totalPages = document.querySelector(selectors.totalPages);
    const currentPage = document.querySelector(selectors.currentPage);
    const nextUrl = document.querySelector(selectors.nextUrl);

    if (!loadMoreButton || !totalPages || !currentPage || !nextUrl) {
      return;
    }

    loadMoreButton.addEventListener("click", (e) => {
      e.preventDefault();

      const totalPagesValue = Number(totalPages.value);
      let currentPageValue = parseInt(currentPage.value);
      let nextUrlValue = nextUrl.value;

      loadMoreButton.setAttribute("disabled", true);

      const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
      const loaderText = loadMoreButton.querySelector(selectors.loaderText);

      loadMoreText.classList.add(hideClass);
      loaderText.classList.remove(hideClass);

      fetch(nextUrlValue)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const products = doc.querySelectorAll(selectors.products);
          insertProducts(products);

          const newUrl = nextUrlValue;
          
          currentPageValue = currentPageValue + 1;
          currentPage.value = currentPageValue;

          if (currentPageValue >= totalPagesValue) {
            loadMoreButton.classList.add(hideClass);
            if (loadMoreContainer) {
              loadMoreContainer.classList.add(hideClass);
            }

            if (currentProducts && totalProducts) {
              currentProducts.innerHTML = totalProducts.innerHTML;
            }
          } else {
            // Update the next URL for the next page
            const baseUrl = window.location.pathname;
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set('page', currentPageValue + 1);
            nextUrl.value = baseUrl + '?' + searchParams.toString();
          }

          loadMoreButton.removeAttribute("disabled");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);

          window.history.pushState(
            {
              param: Shopify.queryParams,
            },
            document.title,
            newUrl
          );
        })
        .catch((error) => {
          console.warn("Loading more products failed", error);
          loadMoreButton.classList.add(hideClass);
          if (loadMoreContainer) {
            loadMoreContainer.classList.add(hideClass);
          }
        });
    });
  }

  function insertProducts(products, before = false) {
    const selectors = {
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      productCard: ".grid-item.product-item:not(.product-grid-item-placeholder)"
    };

    const productGrid = document.querySelector(selectors.productGrid);

    products.forEach((product) => {
      if (before) {
        productGrid.prepend(product);
      } else {
        productGrid.appendChild(product);
      }
    });

    // Update current products count if the element exists
    const currentProducts = document.querySelector(selectors.currentProducts);
    if (currentProducts) {
      const totalProductCards = productGrid.querySelectorAll(selectors.productCard).length;
      currentProducts.innerHTML = totalProductCards;
    }
  }

  registerInfiniteScrollLoadMoreButton();

  // MULTICOLUMN SLIDER ARROW NAVIGATION
  function initMulticolumnSliderArrows() {
    const multicolumnSections = document.querySelectorAll('.section-columns');
    
    multicolumnSections.forEach(section => {
      const arrowsContainer = section.querySelector('.multicolumn-arrows');
      const slider = section.querySelector('[data-grid-slider]');
      
      // Only proceed if this section has arrows and a slider
      if (!arrowsContainer || !slider) return;
      
      const prevButton = arrowsContainer.querySelector('[data-button-prev]');
      const nextButton = arrowsContainer.querySelector('[data-button-next]');
      
      if (!prevButton || !nextButton) return;
      
      // Get all slides in this slider
      const slides = slider.querySelectorAll('[data-grid-item]');
      if (slides.length === 0) return;
      
      // Function to go to next slide
      function nextSlide() {
        const firstVisibleSlide = slider.querySelector('[data-grid-item].is-visible');
        if (firstVisibleSlide) {
          const nextSlide = firstVisibleSlide.nextElementSibling;
          if (nextSlide) {
            slider.scrollTo({
              top: 0,
              left: nextSlide.offsetLeft,
              behavior: 'smooth'
            });
          }
        }
      }
      
      // Function to go to previous slide
      function prevSlide() {
        const firstVisibleSlide = slider.querySelector('[data-grid-item].is-visible');
        if (firstVisibleSlide) {
          const prevSlide = firstVisibleSlide.previousElementSibling;
          if (prevSlide) {
            slider.scrollTo({
              top: 0,
              left: prevSlide.offsetLeft,
              behavior: 'smooth'
            });
          }
        }
      }
      
      // Function to update button states based on visible slides
      function updateButtonStates() {
        const firstSlide = slides[0];
        const lastSlide = slides[slides.length - 1];
        
        // Check if first slide is visible (prev button should be disabled)
        const isFirstVisible = firstSlide.classList.contains('is-visible');
        prevButton.disabled = isFirstVisible;
        
        // Check if last slide is visible (next button should be disabled)
        const isLastVisible = lastSlide.classList.contains('is-visible');
        nextButton.disabled = isLastVisible;
      }
      
      // Add click event listeners
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        prevSlide();
      });
      
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        nextSlide();
      });
      
      // Initialize button states
      updateButtonStates();
      
      // Watch for changes in the visible class on first and last slides
      const firstSlide = slides[0];
      const lastSlide = slides[slides.length - 1];
      
      if (firstSlide && lastSlide) {
        const observer = new MutationObserver(() => {
          updateButtonStates();
        });
        
        observer.observe(firstSlide, {
          attributes: true,
          attributeFilter: ['class']
        });
        
        observer.observe(lastSlide, {
          attributes: true,
          attributeFilter: ['class']
        });
        
        // Store observer for cleanup
        section._multicolumnObserver = observer;
      }
    });
  }
  
  // Initialize multicolumn arrows when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMulticolumnSliderArrows);
  } else {
    initMulticolumnSliderArrows();
  }
  
  // Re-initialize on Shopify section updates
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-columns')) {
      setTimeout(initMulticolumnSliderArrows, 100);
    }
  });
  
  // Clean up on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.classList.contains('section-columns') && event.target._multicolumnObserver) {
      event.target._multicolumnObserver.disconnect();
    }
  });
  
  // Clean up on section reorder
  document.addEventListener('shopify:section:reorder', (event) => {
    if (event.target.classList.contains('section-columns')) {
      setTimeout(initMulticolumnSliderArrows, 100);
    }
  });


  const currencySymbols = {
    'kr': 'kr',
    'dkk': 'kr',
    'DKK': 'kr',
    'EUR': '€',
    'SEK': 'kr',
  };

  const translations = {
    international: {
      shipping: "Shipping",
      free: "Calculated at checkout",
      rebuy_cart_title_widget: "Something for you?",
      rebuy_cart_title: "Cart",
      your_order_has_free_shipping: "Your order has free shipping.",
      progress_bar_label: `You are {{remaining_amount}} away from free shipping`,
      rebuy_subtotal: "Subtotal",
      delivery_text: "Delivery",
      total_text: "Total",
      remove_cart_item: "Remove",
      your_cart_is_empty: "Your cart is empty!",
      add_your_favorite_items: "Add your favorite items to your cart.",
      empty_cart_shop_button: "Shop now",
      shopping_cart: "Shopping Cart",
      something_for_you: "Something for you?",
      failed_to_calculate_delivery: "Failed to calculate delivery",
      go_to_checkout: "Go to checkout",
      terms_and_conditions: "You must accept our terms and conditions.",
      add_comment_label: "Add an optional comment (e.g. Item placement location?)",
      notes_placeholder: "",
      characters_remaining: `You have <strong>{{count}} characters</strong> remaining.`,
    },
    denmark: {
      shipping: "Levering",
      free: "Gratis",
      rebuy_cart_title_widget: "Noget for dig?",
      rebuy_cart_title: "Indkøbskurv",
      your_order_has_free_shipping: "Din ordre har gratis levering.",
      progress_bar_label: `Du er {{remaining_amount}} fra fri fragt`,
      rebuy_subtotal: "Subtotal",
      delivery_text: "Levering",
      total_text: "Total",
      remove_cart_item: "Fjern",
      your_cart_is_empty: "Din indkøbskurv er tom!",
      add_your_favorite_items: "Tilføj dine yndlingsvarer til din indkøbskurv.",
      empty_cart_shop_button: "Shop Nu",
      shopping_cart: "Indkøbskurv",
      something_for_you: "Noget for dig?",
      failed_to_calculate_delivery: "Kunne ikke beregne levering",
      go_to_checkout: "Gå til kassen",
      terms_and_conditions: "Du skal acceptere vores vilkår og betingelser.",
      add_comment_label: "Tilføj en valgfri kommentar (fx hvor må varen stilles?)",
      notes_placeholder: "",
      characters_remaining: `Du har {{count}} tegn tilbage.`,
    },
    germany: {
      shipping: "Versand",
      free: "Kostenlos",
      rebuy_cart_title_widget: "Etwas für dich?",
      rebuy_cart_title: "Warenkorb",
      your_order_has_free_shipping: "Ihre Bestellung hat kostenlosen Versand.",
      progress_bar_label: `Du bist {{remaining_amount}} von kostenlosem Versand entfernt`,
      rebuy_subtotal: "Zwischensumme",
      delivery_text: "Lieferung",
      total_text: "Gesamt",
      remove_cart_item: "Entfernen",
      your_cart_is_empty: "Ihr Warenkorb ist leer!",
      add_your_favorite_items: "Fügen Sie Ihre Lieblingsartikel zu Ihrem Warenkorb hinzu.",
      empty_cart_shop_button: "Jetzt shoppen",
      shopping_cart: "Warenkorb",
      something_for_you: "Etwas für dich?",
      failed_to_calculate_delivery: "Lieferung konnte nicht berechnet werden",
      go_to_checkout: "Zur Kasse",
      terms_and_conditions: "Sie müssen unsere Allgemeinen Geschäftsbedingungen akzeptieren.",
      add_comment_label: "Optionaler Kommentar (z. B. Abstellort?)",
      notes_placeholder: "",
      characters_remaining: `Sie haben noch <strong>{{count}} Zeichen</strong>.`,
    },
    sweden: {
      shipping: "Frakt",
      free: "Gratis",
      rebuy_cart_title_widget: "Något för dig?",
      rebuy_cart_title: "Varukorg",
      your_order_has_free_shipping: "Din beställning har fri frakt.",
      progress_bar_label: `Du är {{remaining_amount}} från fri frakt`,
      rebuy_subtotal: "Delsumma",
      delivery_text: "Leverans",
      total_text: "Totalt",
      remove_cart_item: "Ta bort",
      your_cart_is_empty: "Din varukorg är tom!",
      add_your_favorite_items: "Lägg till dina favoritprodukter i varukorgen.",
      empty_cart_shop_button: "Handla nu",
      shopping_cart: "Varukorg",
      something_for_you: "Något för dig?",
      failed_to_calculate_delivery: "Kunde inte beräkna leverans",
      go_to_checkout: "Gå till kassan",
      terms_and_conditions: "Du måste godkänna våra villkor.",
      add_comment_label: "Lägg till en valfri kommentar (t.ex. var får varan ställas?)",
      notes_placeholder: "",
      characters_remaining: `Du har <strong>{{count}} tecken</strong> kvar.`,
    },
  };

  // translations
   // "remove item" text based on translation
   function setRemoveItemText() {
    const marketHandle = getMarketHandle();
    const removeItemButtons = document.querySelectorAll('.rebuy-cart__flyout-item-remove span');
    removeItemButtons.forEach(button => {
      button.textContent = translations[marketHandle]?.remove_cart_item || translations.denmark.remove_cart_item;
      // button.classList.add('rebuy_remove_text_style');
    });
  }

  // translate if cart is empty
  function translateEmptyCartText() {
    const marketHandle = getMarketHandle();
    const emptyCartElement = document.querySelector('.rebuy-cart__flyout-empty-cart h4');
    const emptyCartSubtextElement = document.querySelector('.rebuy-cart__flyout-empty-cart p');
    const emptyCartButtonElement = document.querySelector('.rebuy-cart__flyout-empty-cart a');

    if (emptyCartElement && emptyCartSubtextElement) {
      emptyCartElement.textContent = translations[marketHandle]?.your_cart_is_empty || translations.denmark.your_cart_is_empty;
      emptyCartSubtextElement.textContent = translations[marketHandle]?.add_your_favorite_items || translations.denmark.add_your_favorite_items;
      emptyCartButtonElement.textContent = translations[marketHandle]?.empty_cart_shop_button || translations.denmark.empty_cart_shop_button;
    }
  }

  // translate cart notes label and placeholder
  function translateCartNotes() {
    const marketHandle = getMarketHandle();
    const notesLabelElement = document.querySelector('.rebuy-cart__notes-toggle-label');
    const notesTextareaElement = document.querySelector('#rebuy-cart__notes');

    if (notesLabelElement) {
      notesLabelElement.textContent = translations[marketHandle]?.add_comment_label || translations.denmark.add_comment_label;
    }

    if (notesTextareaElement) {
      notesTextareaElement.placeholder = translations[marketHandle]?.notes_placeholder || translations.denmark.notes_placeholder;
    }

    // Override the notesRemainingCharacters method to use our translations
    if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
      const originalMethod = Rebuy.SmartCart.notesRemainingCharacters;
      
      if (originalMethod && !Rebuy.SmartCart.notesRemainingCharacters._translated) {
        Rebuy.SmartCart.notesRemainingCharacters = function() {
          const notesData = this.getNotesData();
          const settings = this.getNotesSettings();
          const maxLength = settings.max_length || 250;
          const currentLength = notesData.value ? notesData.value.length : 0;
          const remaining = maxLength - currentLength;
          
          const marketHandle = getMarketHandle();
          const translation = translations[marketHandle]?.characters_remaining || translations.denmark.characters_remaining;
          return translation.replace('{{count}}', remaining);
        };
        Rebuy.SmartCart.notesRemainingCharacters._translated = true;
      }
    }
  }
  
   // translate hard coded strings based on market handle 
   function translateCartTitles(){
    const marketHandle = getMarketHandle();
    // indkøbskurv
    const cartTitle = document.querySelector('#rebuy-cart-title');
    if (cartTitle) {
      cartTitle.textContent = translations[marketHandle]?.rebuy_cart_title || translations.international.rebuy_cart_title;
    }
    
    // noget for dig ?
    const cartTitleWidget = document.querySelector('#rebuy-cart-title-widget');
    if (cartTitleWidget) {
      cartTitleWidget.textContent = translations[marketHandle]?.rebuy_cart_title_widget || translations.international.rebuy_cart_title_widget;
    }

    // terms and conditions label
    const termsAndConditions = document.querySelector('.rebuy-cart__flyout-terms-label');
    if (termsAndConditions) {
      const labelText =
        translations[marketHandle]?.terms_and_conditions ||
        translations.international.terms_and_conditions;

      // the href is always the same so we don't need to check based on market
      termsAndConditions.innerHTML = `
        <a
          href="/policies/privacy-policy"
          class="rebuy-cart__flyout-terms-link"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration: 1px solid underline; color: inherit;"
        >
          ${labelText}
        </a>
      `;
    }

    // go to checkout button
    const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');
    if (checkoutButton) {
      checkoutButton.textContent = (translations[marketHandle]?.go_to_checkout || translations.international.go_to_checkout).toUpperCase();
    }
  }

  // Helper function to get current market handle from currency
  function getMarketHandle() {
    const country = Shopify.locale.toLowerCase();

    switch(country) {
      case 'dk':
        return 'denmark';
      case 'da':
        return 'denmark';
      case 'de':
        return 'germany';
      case 'sv':
        return 'sweden';
      case 'se':
        return 'sweden';
      default:
        return 'international';
    }
  }

  // Store last known cart subtotal so the MutationObserver can use it
  let lastKnownSubtotal = 0;

  // Helper function to get cart data from multiple sources
  function getCartData(providedCart = null) {
    let subtotalPrice = 0;
    
    // Try provided cart first
    if (providedCart?.items_subtotal_price) {
      subtotalPrice = providedCart.items_subtotal_price;
      lastKnownSubtotal = subtotalPrice;
      return subtotalPrice;
    }
    
    // Try rebuy cart
    if (window.rebuyCart?.cart?.items_subtotal_price) {
      subtotalPrice = window.rebuyCart.cart.items_subtotal_price;
      lastKnownSubtotal = subtotalPrice;
      return subtotalPrice;
    }
    
    // Try Shopify cart
    if (typeof Shopify !== 'undefined' && Shopify.cart?.total_price) {
      subtotalPrice = Shopify.cart.total_price;
      lastKnownSubtotal = subtotalPrice;
      return subtotalPrice;
    }
    
    // Fall back to last known subtotal (used when MutationObserver triggers without cart data)
    return lastKnownSubtotal;
  }

  // Helper function to format currency like Rebuy does
  function formatCurrency(amountInCents, currency) {
    const amount = amountInCents / 100;
    
    const symbol = currencySymbols[currency] || currency;
    
    // Format like "kr 1,234.56" to match Rebuy's format
    if (currency === 'DKK' || currency === 'dkk' || currency === 'kr') {
      return `${symbol} ${amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    } else if (currency === 'SEK' || currency === 'sek') {
      return `${symbol} ${amount.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    } else {
      return `${symbol}${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
  }


  // PROGRESS BAR
  function updateProgressBarLabel(marketHandle) {
    // Update Rebuy's SmartCart settings directly instead of manipulating DOM
    if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart && Rebuy.SmartCart.settings) {
      const components = Rebuy.SmartCart.settings.components;
      const translation = translations[marketHandle] || translations.international;
      
      if (components) {
        const announcementBar = components.find(c => c.type === 'tiered_progress_bar');
        
        if (announcementBar && announcementBar.settings && announcementBar.settings.bars) {
          const progressLabelRemainingAmount = translation.progress_bar_label;
          const progressLabelFreeShipping = translation.your_order_has_free_shipping;
          
          if (progressLabelRemainingAmount && progressLabelFreeShipping) {
            // Update each progress bar's language settings
            announcementBar.settings.bars.forEach(bar => {
              if (bar.language) {
                bar.language.free_shipping_remaining = progressLabelRemainingAmount;
                bar.language.free_shipping_reached = progressLabelFreeShipping;
              }
            });
          }
        }
      }
    }
  }

  // Smart Cart Ready
  document.addEventListener("rebuy:smartcart.ready", (event) => {
    // Get cart from event - try multiple possible paths
    const cart = event.detail?.smartcart?.cart || event.detail?.cart?.cart || event.detail?.cart || null;
    // Call getMarketHandle() for translations
    const marketHandle = getMarketHandle(); 
    
    estimatedDelivery(cart);
    setRemoveItemText();
    translateEmptyCartText();
    updateProgressBarLabel(marketHandle);
    // Delay translateCartNotes to ensure DOM is fully updated before applying translations
    setTimeout(() => {
      translateCartNotes();
      translateCartTitles();
      updateInternationalLineItemPrices();
    }, 10);
    // Hide progress bar only for international market
    hideInternationalProgressBarOnce();
  });

  // Smart Cart Change (handles add, remove, quantity changes, etc.)
  document.addEventListener("rebuy:cart.change", (event) => {
    updateCartCount(event.detail.cart.cart);
    // Get cart from event - try multiple possible paths
    const cart = event.detail?.smartcart?.cart || event.detail?.cart?.cart || event.detail?.cart || null;

    // Call getMarketHandle() for translations
    const marketHandle = getMarketHandle(); 

    estimatedDelivery(cart);
    // Delay setRemoveItemText to ensure DOM is fully updated before applying translations
    setTimeout(() => {
      setRemoveItemText();
      translateEmptyCartText();
      translateCartNotes();
      updateProgressBarLabel(marketHandle);
      translateCartTitles();
      updateInternationalLineItemPrices();
    }, 10);
    
    // make sure the "Total" span gets text content when the rebuy cart is ready after changing
    const totalElement = document.querySelector('.rebuy_total_text');
    if (totalElement) {
      totalElement.textContent = translations[marketHandle]?.total_text || translations.international.total_text;
    }
    // Hide progress bar only for international market
    hideInternationalProgressBarOnce();
  });

  function updateCartCount(cart) {
    if (!cart) return;
    
    const headerCartStatuses = document.querySelectorAll('.header__cart__status');
    if (headerCartStatuses && headerCartStatuses.length > 0) {
      headerCartStatuses.forEach(__ => __.textContent = cart.item_count);
    }
  }

  // Fix incorrect Rebuy line-item prices on non-DK markets (e.g. Sweden, Germany).
  // Rule: if the DOM shows a higher price than cart.js final_line_price, the DOM value
  // IS the compare-at. Rewrite with the correct sale price + strikethrough.
  function updateInternationalLineItemPrices() {
    if (getMarketHandle() === 'denmark') return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
        const currency = cart.currency || Shopify.currency.active;
        const lineEls = document.querySelectorAll('.rebuy-cart__flyout-item');
        if (!lineEls.length) return;

        cart.items.forEach((item, idx) => {
          const lineEl = lineEls[idx];
          if (!lineEl) return;

          const priceEl = lineEl.querySelector(
            '.rebuy-cart__flyout-item-price, .rebuy-cart__flyout-item-pricing'
          );
          if (!priceEl) return;

          // Read only the sale span if we already corrected this item, to avoid
          // parsing both prices as one concatenated string.
          const saleSpan = priceEl.querySelector('.rebuy-money.sale span:last-child');
          const displayText = (saleSpan || priceEl).textContent
            .replace(/[^\d,.]/g, '')
            .replace(/\.(?=\d{3}(?:\D|$))/g, '')
            .replace(',', '.');
          const displayedCents = Math.round(parseFloat(displayText) * 100);

          const finalPrice = item.final_line_price;

          // DOM shows a higher price than cart.js — that higher value is the compare-at.
          if (!isNaN(displayedCents) && displayedCents > finalPrice) {
            priceEl.innerHTML =
              `<div class="rebuy-cart__flyout-item-price-has-sale-wrapper">` +
                `<span class="rebuy-money sale">` +
                  `<span class="sr-only">Sale price</span>` +
                  `<span>${formatCurrency(finalPrice, currency)}</span>` +
                `</span>` +
                `<span class="rebuy-money compare-at">` +
                  `<span class="sr-only">Original price</span>` +
                  `<span>${formatCurrency(displayedCents, currency)}</span>` +
                `</span>` +
              `</div>`;
          }
        });
      })
      .catch(err => console.log('Could not update line item prices:', err));
  }
  /* ============================================================
   * Rebuy widget localisation (title / body / handle / price)
   * ------------------------------------------------------------
   * Rebuy's storefront config for this shop has Shopify Markets
   * disabled, so widget products arrive with the default-locale
   * (Danish) handle, title, body_html and the DKK price. Our product
   * handles are translated per market, so anything that fetches
   * /products/{danish-handle}.js on manis-h.se or manis-h.de gets a
   * 404: that breaks both Rebuy's own price repair and the
   * ShopifyStorefrontHelper.
   *
   * Fix: on every productsChange, ask Rebuy's API for the same
   * product ids WITH country_code + locale (this only needs the
   * public key already present in Rebuy.shop), copy back the market
   * handle / title / body_html, then let the storefront helper pull
   * the real price from Shopify's /products/{market-handle}.js.
   * Prices are never taken from Rebuy's response: they are FX
   * estimates and do not match the market catalog.
   * ============================================================ */
  (function setupRebuyWidgetLocalisation() {
    /* ---------- Flow, in one paragraph ----------
     * Rebuy fires `rebuy.productsChange` every time a widget receives its
     * products (first render, after an add-to-cart, after a data-source
     * refresh). At that moment the products are still Danish / DKK. We then:
     *   1. hide()            -> body class so the Danish data is never visible
     *   2. fetchLocalized()  -> ask Rebuy for the same ids WITH market params;
     *                           we only keep handle / title / body_html
     *   3. applyToWidget()   -> write those onto Rebuy's product objects, then
     *                           let Rebuy's own ShopifyStorefrontHelper fetch
     *                           /products/{market-handle}.js for the real price
     *   4. forceRender()     -> tell the widget's Vue instance to repaint
     *   5. reveal()          -> remove the body class once every product is done
     * A 4 s timer guarantees step 5 even if a request never comes back.
     */

    // custom.css hides `.rebuy-product-title` and `.rebuy-money` inside any
    // `[data-rebuy-id]` widget while <body> carries this class. It lives on
    // <body> rather than on the widget element because Smart Cart re-creates
    // the widget placeholder on every re-render, which would drop the class.
    const LOCALIZING_CLASS = 'rebuy-localizing';
    const REVEAL_TIMEOUT_MS = 4000;            // upper bound for how long the widget may stay hidden
    // Public read-only endpoint. Returns the given product ids; with
    // country_code + locale the handle / title / body_html come back for
    // that market. Prices in this response are FX estimates, so we ignore them.
    const REBUY_STATIC_PRODUCTS_URL = 'https://rebuyengine.com/api/v1/products/static';

    let localizedById = {};   // product id -> { handle, title, body_html } for the current market
    let inflight = null;      // Promise chain: several productsChange events in a row share one API call
    let activeJobs = 0;       // how many widgets are being localised right now (0 = safe to reveal)
    let revealTimer = null;   // the safety timer handle, so we can reset it on every hide()

    /* ---------- Show / hide ---------- */

    // Add the body class and (re)arm the safety timer. Called at script start
    // and on every productsChange, so each localisation round gets a fresh 4 s.
    const hide = () => {
      document.body?.classList.add(LOCALIZING_CLASS);
      if (revealTimer) clearTimeout(revealTimer);
      revealTimer = setTimeout(() => { activeJobs = 0; reveal(); }, REVEAL_TIMEOUT_MS);
    };

    // Remove the body class, but only when no widget is still being worked on.
    // With two widgets on a page we must wait for both before revealing.
    const reveal = () => {
      if (activeJobs > 0) return;
      document.body?.classList.remove(LOCALIZING_CLASS);
      if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
    };

    // One widget finished (successfully or not). Decrement and try to reveal.
    const jobDone = () => {
      activeJobs = Math.max(0, activeJobs - 1);
      reveal();
    };

    /* ---------- Market detection ---------- */

    // "Primary" = the market Rebuy already serves correctly (Danish, DKK).
    // We read Rebuy's own idea of the shop's primary locale and currency
    // instead of hard-coding 'da' / 'DKK', with those as fallbacks.
    const isPrimaryMarket = () => {
      const shop = window.Rebuy?.shop || {};
      const primaryLocale = shop.primary_locale || 'da';
      const shopCurrency = shop.currency || 'DKK';
      const locale = window.Shopify?.locale;
      const currency = window.Shopify?.currency?.active;
      return locale === primaryLocale && currency === shopCurrency;
    };

    // Rebuy's own Shopify Markets support. When the account has it enabled,
    // Rebuy sends country_code + locale on every widget request itself and
    // re-fetches prices from Shopify with the market handle, so this whole
    // workaround must step aside. `shop` is either Rebuy's live config
    // (window.Rebuy.shop, once the runtime has loaded) or the raw config
    // object from window.__rebuyConfigFetch (available earlier).
    const rebuyMarketsEnabled = (shop = window.Rebuy?.shop) => shop?.markets?.enabled === true;

    /* ---------- Session cache ----------
     * The id -> market handle map is stable for a session, so we keep it in
     * sessionStorage. On the next page view fetchLocalized() finds nothing
     * "missing" and skips the Rebuy round-trip entirely. (The storefront
     * helper caches the Shopify product JSON in sessionStorage as well, so
     * repeat views render localised almost instantly.)
     * The key includes country + locale so switching market never reuses
     * the wrong handles.
     */
    const cacheKey = () => {
      const country = window.Shopify?.country || '';
      const locale = window.Shopify?.locale || '';
      return `rebuyLocalized:${country}:${locale}`;
    };

    const loadCache = () => {
      try {
        const raw = window.sessionStorage?.getItem(cacheKey());
        if (raw) localizedById = JSON.parse(raw) || {};
      } catch (e) {
        // sessionStorage can throw in private mode / when blocked; start empty
        localizedById = {};
      }
    };

    const saveCache = () => {
      try {
        window.sessionStorage?.setItem(cacheKey(), JSON.stringify(localizedById));
      } catch (e) {
        // storage unavailable or full: the fix still works, just without the cache
      }
    };

    /* ---------- Step 2: get market handles from Rebuy ---------- */

    // Resolves when localizedById contains every id we can get. Never rejects:
    // on any failure we log and resolve, and applyToWidget() simply skips the
    // products it has no data for (they keep Rebuy's Danish data).
    const fetchLocalized = (ids) => {
      // Only ask for ids we have not seen this session.
      const missing = ids.filter((id) => !localizedById[id]);
      if (!missing.length) return Promise.resolve();

      // Everything we need is already on the page: Rebuy exposes the shop's
      // public API key, Shopify exposes country and locale of the current market.
      const key = window.Rebuy?.shop?.api_key;
      const country = window.Shopify?.country;
      const locale = window.Shopify?.locale;
      if (!key || !country || !locale) return Promise.resolve();

      const params = new URLSearchParams({
        key,
        ids: missing.join(','),
        limit: String(missing.length),
        country_code: country,   // e.g. SE  -> market-specific handle
        locale,                  // e.g. sv  -> translated title / body_html
      });

      return fetch(`${REBUY_STATIC_PRODUCTS_URL}?${params.toString()}`)
        .then((r) => (r.ok ? r.json() : null))
        .then((json) => {
          const data = json?.data || [];
          data.forEach((p) => {
            if (p?.id && p.handle) {
              // Deliberately NOT storing p.variants[].price: those are Rebuy's
              // FX estimates and did not match the market catalog in testing.
              localizedById[p.id] = { handle: p.handle, title: p.title, body_html: p.body_html };
            }
          });
          if (data.length) saveCache();
        })
        .catch((err) => {
          console.log('[rebuy-localisation] Could not fetch market product data:', err);
        });
    };

    /* ---------- Step 4: repaint ---------- */

    // Rebuy widgets are Vue instances; mutating the product objects in place
    // is usually picked up by reactivity, but a $forceUpdate makes it certain.
    const forceRender = (widget) => {
      const vue = widget?.View?.vue;
      if (typeof vue?.$forceUpdate === 'function') vue.$forceUpdate();
    };

    /* ---------- Step 3: write market data onto Rebuy's products ---------- */

    const applyToWidget = (widget) => {
      const products = widget?.data?.products;
      if (!products || !products.length) { jobDone(); return; }

      // ShopifyStorefrontHelper is Rebuy's own script (loaded in theme.liquid).
      // updateProductJSON(product, cb) fetches /products/{product.handle}.js and
      // overwrites title, body_html and variant price / compare_at_price with
      // Shopify's values for the current market. It only works once
      // product.handle is the market handle, which is what we fix first.
      const helper = typeof ShopifyStorefrontHelper === 'function' ? new ShopifyStorefrontHelper() : null;
      let pending = 0;   // helper calls still waiting for their callback

      products.forEach((product) => {
        const localized = localizedById[product.id];
        if (!localized) return;   // no market data for this id: leave it as Rebuy delivered it

        product.handle = localized.handle;   // the key change: /products/{handle}.js now resolves
        if (localized.title) product.title = localized.title;
        if (localized.body_html) product.body_html = localized.body_html;

        if (typeof helper?.updateProductJSON === 'function') {
          pending += 1;
          helper.updateProductJSON(product, () => {
            pending -= 1;
            // Last callback in: repaint with Shopify prices and reveal.
            if (pending === 0) { forceRender(widget); jobDone(); }
          });
        }
      });

      // Repaint right away with the translated titles; prices follow when the
      // helper callbacks arrive. If the helper was unavailable there is nothing
      // more to wait for, so finish the job now.
      forceRender(widget);
      if (pending === 0) jobDone();
    };

    /* ---------- Wiring ---------- */

    loadCache();

    // Hide immediately so the very first Rebuy render is never visible in
    // Danish / DKK. custom.css only applies the rule under the sweden /
    // germany / international body classes, so DK pages are unaffected. If no
    // widget ever fires productsChange, the timer inside hide() reveals anyway.
    hide();

    // Rebuy is not loaded yet at this point, but rebuy.js (loaded at the end of
    // <body>) has already exposed its config as a promise. If Rebuy Markets is
    // on for this shop, lift the hide straight away instead of waiting for the
    // first productsChange event or the safety timer.
    const configPromise = window.__rebuyConfigFetch;
    if (typeof configPromise?.then === 'function') {
      configPromise.then((cfg) => {
        if (rebuyMarketsEnabled(cfg?.data?.shop)) { activeJobs = 0; reveal(); }
      }).catch(() => {});
    }

    document.addEventListener('rebuy.productsChange', (e) => {
      const widget = e.detail?.widget;
      const products = widget?.data?.products;
      if (!products || !products.length) return;

      // Nothing to do on the primary market, or when Rebuy localises the
      // widget itself (Shopify Markets enabled on the Rebuy account):
      // make sure nothing stays hidden and leave Rebuy's data untouched.
      if (isPrimaryMarket() || rebuyMarketsEnabled()) { activeJobs = 0; reveal(); return; }

      // Rebuy has just (re)delivered Danish data for this widget: hide again
      // and count this widget as in progress.
      activeJobs += 1;
      hide();

      const ids = products.map((p) => p.id).filter(Boolean);
      // On fetch success -> apply; on the (unlikely) rejection -> just release
      // the job so the widget is revealed as-is rather than staying hidden.
      const run = () => fetchLocalized(ids).then(() => applyToWidget(widget), () => jobDone());
      // Chain onto whatever is already running so bursts of events run in
      // order and reuse the cache filled by the previous call.
      inflight = (inflight || Promise.resolve()).then(run, run);
    });
  })();

  // Progress bar on international page
  function hideInternationalProgressBarOnce() {
    const isInternationalBody = document.body && document.body.classList.contains('shop-market-international');
    const isInternational = getMarketHandle() === 'international';
    const progressBar = document.querySelectorAll('[data-rebuy-component="progress-bar"]');

    if (!isInternationalBody || !isInternational) return;

    progressBar.forEach(progressBar => { progressBar.style.display = 'none'; });
  }

  // ESTIMATED DELIVERY
  function estimatedDelivery(cart = null, retryCount = 0) {
    setTimeout(() => {
      
      // Find the delivery value element and total element
      const estimatedDeliveryValue = document.querySelector(".rebuy_delivery_value");
      const totalAmountElement = document.querySelector(".rebuy_total_amount_div span:last-child");
      
      if (!estimatedDeliveryValue) {
        // Element not in DOM yet (Rebuy still rendering) — retry up to 5 times
        if (retryCount < 5) {
          estimatedDelivery(cart, retryCount + 1);
        }
        return;
      }
      const currency = Shopify.currency.active;

      // filter through the currencies to see which one matches the current one
      // use the value from that match to display the actual correct currency symbol
      const getCorrectSymbol = (currency) => {
        return currencySymbols[currency.toUpperCase()] || currency;
      };

      const locale = Shopify.locale || "en";
      const marketHandle = getMarketHandle();
    
      // Get cart data using helper function that checks multiple sources
      let subtotalPrice = getCartData(cart);
      
      // If we still have no cart data, fetch from /cart.js and re-run
      if (subtotalPrice === 0 && retryCount === 0) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(r => r.json())
          .then(fetchedCart => {
            lastKnownSubtotal = fetchedCart.items_subtotal_price || 0;
            estimatedDelivery(fetchedCart);
          })
          .catch(() => {});
        // Continue below to at least show formatted price (even if free shipping check is wrong)
      }
      
      // International carts should always show delivery as "free" (Calculated at checkout)
      const isInternational = (document.body && document.body.classList.contains('shop-market-international')) || marketHandle === 'international';
      if (isInternational) {
        estimatedDeliveryValue.textContent = translations[marketHandle]?.free || translations.international.free;
        if (totalAmountElement && subtotalPrice > 0) {
          totalAmountElement.innerHTML = formatCurrency(subtotalPrice, currency);
        }
      } else {
        const deliveryLimitSetting = window.theme?.settings?.[`freeShippingLimit_${marketHandle}`];
        const deliveryPriceSetting = window.theme?.settings?.[`shippingPrice_${marketHandle}`];

        let deliveryPrice = deliveryPriceSetting
          ? Number(deliveryPriceSetting.toString().replace(",", ".")) * 100
          : null;
        const deliveryLimit = deliveryLimitSetting
          ? Number(deliveryLimitSetting) * 100
          : null;

        if (deliveryPrice === null || deliveryLimit === null) {
          // Failed to calculate delivery
          estimatedDeliveryValue.textContent = translations[marketHandle]?.failed_to_calculate_delivery || translations.international.failed_to_calculate_delivery;
          return;
        }

        // Check the comparison
        const isFreeShipping = subtotalPrice >= deliveryLimit;

        // Set delivery cost or "Free" based on cart total
        const resultText = isFreeShipping
          // add the country inside of translations instead of locale rabbit
          ? (translations[getMarketHandle()]?.free || translations.international.free)
          : formatCurrency(deliveryPrice, currency);
          
        estimatedDeliveryValue.textContent = resultText;
        
        // Update total amount if element exists and we have cart data
        if (totalAmountElement && subtotalPrice > 0) {
          const totalPrice = isFreeShipping ? subtotalPrice : subtotalPrice + deliveryPrice;
          const formattedTotal = formatCurrency(totalPrice, currency);
          totalAmountElement.innerHTML = formattedTotal;
        }
      }
    
     // Update the progress bar label with translations
     updateProgressBarLabel(marketHandle);
    
     const subtotalElement = document.querySelector('.rebuy_subtotal_text');
     if (subtotalElement) {
       subtotalElement.textContent = translations[marketHandle]?.rebuy_subtotal || translations.international.rebuy_subtotal;
     }
    
     const deliveryTextElement = document.querySelector('.rebuy_delivery_text');
     if (deliveryTextElement) {
       deliveryTextElement.textContent = translations[marketHandle]?.delivery_text || translations.international.delivery_text;
     }
    
     const totalElement = document.querySelector('.rebuy_total_text');
     if (totalElement) {
       totalElement.textContent = translations[marketHandle]?.total_text || translations.international.total_text;
     }
      
    }, 100);
  }

  // MutationObserver to catch Rebuy re-renders that overwrite the delivery value
  // When Rebuy re-renders its cart DOM, it resets .rebuy_delivery_value to the raw
  // setting value (e.g. "50") without currency formatting. This observer detects that
  // and re-applies the correct formatted delivery text.
  let deliveryObserverActive = false;
  function setupDeliveryObserver() {
    if (deliveryObserverActive) return;
    // Use the top-level rebuy cart element which exists early in the DOM
    const cartContainer = document.querySelector('#rebuy-cart')
      || document.querySelector('.rebuy-cart')
      || document.querySelector('.rebuy-cart__flyout-content') 
      || document.querySelector('[data-rebuy-component="cart-subtotal"]');
    if (!cartContainer) return;

    let isUpdating = false;
    const observer = new MutationObserver(() => {
      if (isUpdating) return;
      const el = document.querySelector('.rebuy_delivery_value');
      if (!el) return;
      const text = el.textContent.trim();
      // If the value is a raw number (no currency symbol/text), Rebuy has overwritten it
      if (text && /^\d+([.,]\d+)?$/.test(text)) {
        isUpdating = true;
        // Fetch fresh cart data from /cart.js to ensure accurate free shipping check
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(r => r.json())
          .then(cart => {
            lastKnownSubtotal = cart.items_subtotal_price || 0;
            estimatedDelivery(cart);
          })
          .catch(() => {
            estimatedDelivery();
          })
          .finally(() => {
            setTimeout(() => { isUpdating = false; }, 200);
          });
      }
    });

    observer.observe(cartContainer, { childList: true, subtree: true, characterData: true });
    deliveryObserverActive = true;
  }

  // Set up observer as early as possible — immediately on smart cart ready
  document.addEventListener("rebuy:smartcart.ready", () => {
    setupDeliveryObserver();
  });
  document.addEventListener("rebuy:cart.change", () => {
    setupDeliveryObserver();
  });

  // Initialize on page load - try to get cart data from rebuy or shopify
  setTimeout(() => {
    let initialCart = null;
    
    // Try to get initial cart data
    if (window.rebuyCart?.cart) {
      initialCart = window.rebuyCart.cart;
    } else if (typeof Shopify !== 'undefined' && Shopify.cart) {
      initialCart = { items_subtotal_price: Shopify.cart.total_price };
    }
    
  }, 100);


  /* ============================================================
   * Cart currency prices monitor
   * ------------------------------------------------------------
   * The Function App that performs cart transforms reads prices from
   * the `_components` JSON line item property. Each component can
   * carry either a single-currency `price` string (legacy) or a
   * `prices` array `[{ currency, value }, ...]` (preferred, lets
   * the Function App pick the matching value when a customer
   * switches market at checkout).
   *
   * - Bundles added via this theme's own flow (bundle-options-advanced.js)
   *   already set `prices` on each component.
   * - Bundles added by external apps may only set `price` on their
   *   components in the cart's active currency.
   *
   * This monitor scans the cart after every change and, for any
   * component that has `price` but no `prices` (or whose `prices`
   * array is missing DKK/SEK/EUR), fetches the variant metafields
   * (custom.price_dkk/sek/eur) and patches `_components` via
   * /cart/change.js so the full `prices` array is present.
   * ============================================================ */
  (function setupCartCurrencyPricesMonitor() {
    var SUPPORTED_CURRENCIES = ['DKK', 'SEK', 'EUR'];
    var COMPONENTS_PROP = '_components';

    // In-memory caches.
    var variantPricesCache = {};       // productHandle -> { variantId -> { DKK, SEK, EUR } }
    var inflightHandlePrices = {};     // productHandle -> Promise
    var variantIdToHandleCache = {};   // variantId(string) -> productHandle | null
    var inflightVariantHandle = {};    // variantId(string) -> Promise
    var patching = {};                 // line key -> true while a patch is in flight
    var lastProcessedFingerprint = null;
    var activePatches = 0;             // refcount for the checkout-button busy state
    var CHECKOUT_BUTTON_SELECTOR = '.rebuy-button.rebuy-cart__checkout-button';

    function setCheckoutButtonsBusy(busy) {
      // Visually disables the Rebuy checkout button while we are patching
      // line item properties, so customers can't proceed to checkout with
      // stale prices. No-op on themes that don't render the Rebuy button.
      var buttons = document.querySelectorAll(CHECKOUT_BUTTON_SELECTOR);
      buttons.forEach(function (btn) {
        if (busy) {
          btn.style.opacity = '0.6';
          btn.style.pointerEvents = 'none';
          btn.setAttribute('aria-busy', 'true');
        } else {
          btn.style.opacity = '';
          btn.style.pointerEvents = '';
          btn.removeAttribute('aria-busy');
        }
      });
    }

    // Safety net: even if a patch hangs (network stall, JS error, missed
    // endBusy(), etc.) the checkout button must never stay locked. This
    // timer force-restores the button after 5s and zeros the refcount.
    var busySafetyTimer = null;
    function armBusySafety() {
      if (busySafetyTimer) clearTimeout(busySafetyTimer);
      busySafetyTimer = setTimeout(function () {
        if (activePatches > 0) {
          console.warn('[cart-currency-prices] Busy safety timeout fired - force-restoring checkout button');
        }
        activePatches = 0;
        setCheckoutButtonsBusy(false);
        busySafetyTimer = null;
      }, 5000);
    }

    function beginBusy() {
      activePatches += 1;
      if (activePatches === 1) setCheckoutButtonsBusy(true);
      armBusySafety();
    }

    function endBusy() {
      activePatches = Math.max(0, activePatches - 1);
      if (activePatches === 0) {
        setCheckoutButtonsBusy(false);
        if (busySafetyTimer) {
          clearTimeout(busySafetyTimer);
          busySafetyTimer = null;
        }
      }
    }

    function activeCurrency() {
      return (
        (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) ||
        'DKK'
      ).toUpperCase();
    }

    function parseProperties(rawProps) {
      // Cart item properties can be an object {key: value} or an array
      // of [key, value] pairs depending on how they were added.
      if (!rawProps) return {};
      if (Array.isArray(rawProps)) {
        var out = {};
        rawProps.forEach(function (pair) {
          if (Array.isArray(pair) && pair.length === 2) out[pair[0]] = pair[1];
        });
        return out;
      }
      if (typeof rawProps === 'object') return rawProps;
      return {};
    }

    function safeParseArray(value) {
      if (Array.isArray(value)) return value;
      if (typeof value !== 'string') return null;
      try {
        var parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : null;
      } catch (e) {
        return null;
      }
    }

    function componentsNeedPatching(componentsJson, currentDiscount) {
      var arr = safeParseArray(componentsJson);
      if (!arr || arr.length === 0) return false;
      return arr.some(function (c) {
        if (!c) return false;
        if (!Array.isArray(c.prices)) return c.price != null;
        var present = {};
        c.prices.forEach(function (p) { if (p && p.currency) present[p.currency.toUpperCase()] = true; });
        if (SUPPORTED_CURRENCIES.some(function (cur) { return !present[cur]; })) return true;
        // All currencies present - re-patch if the applied discount
        // no longer matches the line item's current _discount_percent.
        var applied = Number(c.discount_applied) || 0;
        var current = Number(currentDiscount) || 0;
        return applied !== current;
      });
    }

    function buildOriginalPricesArray(metafieldPrices, fallbackCurrency, fallbackValue) {
      // Undiscounted prices straight from the variant metafields, used as
      // the historical/reference value in `original_prices` on the component.
      // Falls back to the component's initial `price` only if the metafield
      // for the active currency is blank.
      var arr = [];
      SUPPORTED_CURRENCIES.forEach(function (cur) {
        var raw = metafieldPrices && metafieldPrices[cur];
        if (raw != null && raw !== '') {
          arr.push({ currency: cur, value: String(raw) });
        } else if (cur === fallbackCurrency && fallbackValue != null) {
          arr.push({ currency: cur, value: String(fallbackValue) });
        }
      });
      return arr;
    }

    function buildFinalPricesArray(metafieldPrices, fallbackCurrency, fallbackValue, discountPercent) {
      // What the Function App will actually read.
      //  - For the ACTIVE currency, always use the component's initial
      //    `price` (the value set by whoever added the item). This is
      //    the source of truth for what the customer is paying now and
      //    must never be overwritten by a possibly-drifted metafield.
      //  - For the OTHER currencies, use the metafield value with the
      //    line item's `_discount_percent` applied.
      var pct = Number(discountPercent) || 0;
      var multiplier = pct > 0 ? (1 - pct / 100) : 1;
      var arr = [];
      SUPPORTED_CURRENCIES.forEach(function (cur) {
        if (cur === fallbackCurrency) {
          if (fallbackValue != null) {
            arr.push({ currency: cur, value: String(fallbackValue) });
          } else {
            // No initial price set for the active currency - fall back
            // to the (discounted) metafield value so the Function App
            // still gets something.
            var rawActive = metafieldPrices && metafieldPrices[cur];
            if (rawActive != null && rawActive !== '') {
              var nA = Number(String(rawActive).replace(',', '.'));
              if (!isNaN(nA)) {
                arr.push({ currency: cur, value: (Math.round(nA * multiplier * 100) / 100).toString() });
              }
            }
          }
          return;
        }
        var raw = metafieldPrices && metafieldPrices[cur];
        if (raw == null || raw === '') return;
        var n = Number(String(raw).replace(',', '.'));
        if (isNaN(n)) return;
        arr.push({ currency: cur, value: (Math.round(n * multiplier * 100) / 100).toString() });
      });
      return arr;
    }

    function fetchVariantPricesByHandle(handle) {
      if (!handle) return Promise.resolve(null);
      if (variantPricesCache[handle]) return Promise.resolve(variantPricesCache[handle]);
      if (inflightHandlePrices[handle]) return inflightHandlePrices[handle];

      var url = '/products/' + encodeURIComponent(handle) + '?view=variant-prices-json';
      inflightHandlePrices[handle] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var variants = (data && data.variants) || {};
          variantPricesCache[handle] = variants;
          return variants;
        })
        .catch(function (err) {
          console.warn('[cart-currency-prices] Failed to fetch prices for', handle, err);
          return null;
        })
        .finally(function () { delete inflightHandlePrices[handle]; });

      return inflightHandlePrices[handle];
    }

    function resolveVariantHandle(variantId) {
      if (!variantId) return Promise.resolve(null);
      var key = String(variantId);
      if (variantIdToHandleCache[key] !== undefined) {
        return Promise.resolve(variantIdToHandleCache[key]);
      }
      if (inflightVariantHandle[key]) return inflightVariantHandle[key];

      // /variants/{id} redirects to /products/{handle}?variant={id}.
      // We don't need the response body, only the final URL after redirects.
      inflightVariantHandle[key] = fetch('/variants/' + encodeURIComponent(key), {
        credentials: 'same-origin'
      })
        .then(function (r) {
          var handle = null;
          if (r && r.url) {
            var m = r.url.match(/\/products\/([^/?#]+)/);
            if (m) handle = decodeURIComponent(m[1]);
          }
          variantIdToHandleCache[key] = handle;
          return handle;
        })
        .catch(function () {
          variantIdToHandleCache[key] = null;
          return null;
        })
        .finally(function () { delete inflightVariantHandle[key]; });

      return inflightVariantHandle[key];
    }

    function getPricesForVariant(variantId) {
      return resolveVariantHandle(variantId).then(function (handle) {
        if (!handle) return null;
        return fetchVariantPricesByHandle(handle).then(function (variants) {
          return variants ? variants[String(variantId)] || null : null;
        });
      });
    }

    function updateLineItemProperties(item, newProperties) {
      // /cart/update.js with `updates` only changes quantity, not properties.
      // /cart/change.js accepts `id` (line key) + `properties` and merges them.
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: item.key, properties: newProperties })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function (err) {
          console.warn('[cart-currency-prices] cart/change.js failed for line', item.key, err);
          return null;
        });
    }

    function processCart(cart) {
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return Promise.resolve();

      // Skip reprocessing the same cart state (rebuy:cart.change can
      // fire multiple times for a single update).
      var fingerprint = cart.items.map(function (it) {
        return it.key + ':' + it.quantity;
      }).join('|') + '#' + (cart.token || '');
      if (fingerprint === lastProcessedFingerprint) return Promise.resolve();
      lastProcessedFingerprint = fingerprint;

      var currency = activeCurrency();

      var work = [];
      cart.items.forEach(function (item) {
        if (!item || !item.key || patching[item.key]) return;
        var props = parseProperties(item.properties);
        var componentsRaw = props[COMPONENTS_PROP];
        var discountPercent = Number(props['_discount_percent']) || 0;
        if (!componentsNeedPatching(componentsRaw, discountPercent)) return;
        work.push({
          item: item,
          props: props,
          componentsRaw: componentsRaw,
          discountPercent: discountPercent
        });
      });

      if (work.length === 0) return Promise.resolve();

      return work.reduce(function (chain, w) {
        return chain.then(function () { return patchOneLine(w, currency); });
      }, Promise.resolve());
    }

    function patchOneLine(w, currency) {
      patching[w.item.key] = true;
      beginBusy();

      var components = safeParseArray(w.componentsRaw) || [];
      var discountPercent = w.discountPercent || 0;

      return Promise.all(components.map(function (c) {
        if (!c || !c.id) return c;
        // Skip if already has all supported currencies AND the applied
        // discount matches the line item's current _discount_percent.
        if (Array.isArray(c.prices)) {
          var present = {};
          c.prices.forEach(function (p) { if (p && p.currency) present[p.currency.toUpperCase()] = true; });
          var allPresent = SUPPORTED_CURRENCIES.every(function (cur) { return present[cur]; });
          var appliedMatches = (Number(c.discount_applied) || 0) === discountPercent;
          if (allPresent && appliedMatches) return c;
        }
        return getPricesForVariant(c.id).then(function (mfp) {
          var fallback = c.price != null ? c.price : null;
          // `original_prices` = pure metafield values (history/reference).
          var originalPrices = buildOriginalPricesArray(mfp, currency, fallback);
          // `prices` = what the Function App reads. Active currency always
          // uses the component's initial `price`; other currencies use the
          // metafield value with `_discount_percent` applied.
          var finalPrices = buildFinalPricesArray(mfp, currency, fallback, discountPercent);
          if (finalPrices.length === 0 && originalPrices.length === 0) return c;
          var next = Object.assign({}, c, {
            prices: finalPrices,
            original_prices: originalPrices,
            discount_applied: discountPercent
          });
          // Preserve legacy `price` (initial value from whoever added the
          // item) for backward compatibility / history.
          if (next.price == null && fallback != null) next.price = fallback;
          return next;
        });
      })).then(function (updatedComponents) {
        var newComponentsJson = JSON.stringify(updatedComponents);
        if (newComponentsJson === w.componentsRaw) {
          console.log('[cart-currency-prices] No changes needed for line', w.item.key);
          return null;
        }

        console.log('[cart-currency-prices] Patching line', w.item.key, {
          before: safeParseArray(w.componentsRaw),
          after: updatedComponents
        });

        var newProps = Object.assign({}, w.props);
        newProps[COMPONENTS_PROP] = newComponentsJson;
        return updateLineItemProperties(w.item, newProps);
      }).then(function (updatedCart) {
        delete patching[w.item.key];
        endBusy();
        if (updatedCart) {
          console.log('[cart-currency-prices] Line patched successfully', w.item.key);
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      }).catch(function (err) {
        delete patching[w.item.key];
        endBusy();
        console.warn('[cart-currency-prices] Failed to patch line', w.item.key, err);
      });
    }

    function processFromEvent(event) {
      console.log('[cart-currency-prices] Cart change detected via', event && event.type);
      var cart =
        (event && event.detail && (event.detail.smartcart && event.detail.smartcart.cart)) ||
        (event && event.detail && event.detail.cart && event.detail.cart.cart) ||
        (event && event.detail && event.detail.cart) ||
        null;
      if (cart && Array.isArray(cart.items)) {
        processCart(cart);
      } else {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(processCart)
          .catch(function () {});
      }
    }

    console.log('[cart-currency-prices] Registering cart monitor (currencies:', SUPPORTED_CURRENCIES.join(', ') + ')');
    document.addEventListener('rebuy:smartcart.ready', processFromEvent);
    document.addEventListener('rebuy:cart.change', processFromEvent);
    // Theme-native cart events (used by Broadcast's own cart drawer and any
    // code that dispatches them). These fire whether or not Rebuy is loaded,
    // so the monitor keeps working if Rebuy is removed.
    document.addEventListener('theme:cart:refresh', processFromEvent);
    document.addEventListener('theme:cart:add', processFromEvent);
    console.log('[cart-currency-prices] Listening for rebuy:* and theme:cart:* events');

    // Fetch-based fallback: any code path that mutates the cart via Shopify's
    // /cart/add|change|update|clear endpoints will trigger a resweep, even if
    // it never dispatches a cart event. Covers non-Rebuy carts and any third
    // party app that adds to cart silently.
    (function patchFetchForCartMutations() {
      if (typeof window.fetch !== 'function' || window.__cartCurrencyPricesFetchPatched) return;
      window.__cartCurrencyPricesFetchPatched = true;
      var originalFetch = window.fetch.bind(window);
      var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
      // Endpoints our own monitor calls - skip these to avoid recursion.
      var SELF_RE = /\/cart\/change(\.js)?(\?|$)/i;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = (init && init.method) || (input && input.method) || 'GET';
        var isCartMutation = CART_MUTATION_RE.test(url) && method.toUpperCase() !== 'GET';
        // Self-calls from updateLineItemProperties use cart/change.js. We
        // still want third-party cart/change.js calls to trigger a sweep,
        // but our own call already dispatches theme:cart:refresh on success,
        // so the resweep is harmless either way.
        var promise = originalFetch(input, init);
        if (isCartMutation && !SELF_RE.test(url)) {
          promise.then(function (resp) {
            if (!resp || !resp.ok) return;
            // Tiny delay to let the cart settle on Shopify's side.
            setTimeout(function () {
              fetch('/cart.js', { credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(processCart)
                .catch(function () {});
            }, 50);
          }).catch(function () {});
        }
        return promise;
      };
    })();

    // Initial sweep on page load - covers items added before the theme JS was ready.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        console.log('[cart-currency-prices] Running initial cart sweep (DOMContentLoaded)');
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(processCart)
          .catch(function () {});
      });
    } else {
      console.log('[cart-currency-prices] Running initial cart sweep');
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(processCart)
        .catch(function () {});
    }
  })();

  
})();





  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
